"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_WRESTLER: function() {
        return ADD_WRESTLER;
    },
    BOOST_WRESTLER: function() {
        return BOOST_WRESTLER;
    },
    DELETE_WRESTLER: function() {
        return DELETE_WRESTLER;
    },
    DUPLICATE_WRESTLER: function() {
        return DUPLICATE_WRESTLER;
    },
    GENERATE_WRESTLERS: function() {
        return GENERATE_WRESTLERS;
    },
    PENALTY_WRESTLER: function() {
        return PENALTY_WRESTLER;
    },
    RESET_BRAND_ID_FOR_WRESTLERS: function() {
        return RESET_BRAND_ID_FOR_WRESTLERS;
    },
    RESET_WRESTLERS: function() {
        return RESET_WRESTLERS;
    },
    UPDATE_ROSTER: function() {
        return UPDATE_ROSTER;
    },
    UPDATE_WRESTLER: function() {
        return UPDATE_WRESTLER;
    }
});
const ADD_WRESTLER = "ADD_WRESTLER";
const UPDATE_WRESTLER = "UPDATE_WRESTLER";
const RESET_WRESTLERS = "RESET_WRESTLERS";
const UPDATE_ROSTER = "UPDATE_ROSTER";
const DELETE_WRESTLER = "DELETE_WRESTLER";
const DUPLICATE_WRESTLER = "DUPLICATE_WRESTLER";
const GENERATE_WRESTLERS = "GENERATE_WRESTLERS";
const RESET_BRAND_ID_FOR_WRESTLERS = "RESET_BRAND_ID_FOR_WRESTLERS";
const BOOST_WRESTLER = "BOOST_WRESTLER";
const PENALTY_WRESTLER = "PENALTY_WRESTLER";
